import React from 'react';
import PropTypes from 'prop-types';
import PromoModalTidal from './PromoModalTidal';

const PromoModal = props => (
  <div>
    <div className="c-promo-modal_fog" />
    <div className="c-promo-modal">
      {<PromoModalTidal closeModal={props.closeModal} {...props} />}
    </div>
  </div>
);

PromoModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default PromoModal;



// WEBPACK FOOTER //
// ./src/app/reservation/components/PromoModal.jsx